(function () {
  function initVerticalThumbs(slider) {
    if (slider.dataset.verticalInit === 'true') return;
    slider.dataset.verticalInit = 'true';

    var list = slider.querySelector('.thumbnail-list');
    var prev = slider.querySelector('.slider-button--prev');
    var next = slider.querySelector('.slider-button--next');
    if (!list) return;

    function isVerticalLayout() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function step() {
      var first = list.querySelector('.thumbnail-list__item');
      if (!first) return list.clientHeight * 0.6;
      var rect = first.getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(list).rowGap || getComputedStyle(list).gap || '0') || 0;
      return rect.height + gap;
    }

    function canScroll() {
      return list.scrollHeight > list.clientHeight + 1;
    }

    function getThumbnails() {
      return Array.from(list.querySelectorAll('.thumbnail-list__item button.thumbnail'));
    }

    function getActiveIndex(thumbnails) {
      var idx = thumbnails.findIndex(function (t) {
        return t.getAttribute('aria-current') === 'true';
      });
      return idx === -1 ? 0 : idx;
    }

    function navigate(direction) {
      var thumbnails = getThumbnails();
      if (thumbnails.length === 0) return;
      var activeIdx = getActiveIndex(thumbnails);
      var nextIdx = (activeIdx + direction + thumbnails.length) % thumbnails.length;
      thumbnails[nextIdx].click();
    }

    function scrollOrNavigate(direction) {
      if (!isVerticalLayout()) return;
      if (canScroll()) {
        list.scrollBy({ top: direction * step() * 3, behavior: 'smooth' });
      } else {
        navigate(direction);
      }
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        if (!isVerticalLayout()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        scrollOrNavigate(-1);
      }, true);
    }
    if (next) {
      next.addEventListener('click', function (e) {
        if (!isVerticalLayout()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        scrollOrNavigate(1);
      }, true);
    }

    // Dawn's SliderComponent (assets/global.js) re-disables prev/next based on horizontal-slider logic
    // which thinks vertical thumbs are "all at offsetLeft=0 so all visible" -> both disabled.
    // We intercept setAttribute + .disabled property so Dawn's attempts are no-ops.
    function keepEnabled(btn) {
      if (!btn) return;
      btn.removeAttribute('disabled');
      var origSetAttribute = btn.setAttribute.bind(btn);
      btn.setAttribute = function (name, value) {
        if (name === 'disabled') return;
        origSetAttribute(name, value);
      };
      try {
        Object.defineProperty(btn, 'disabled', {
          get: function () { return false; },
          set: function () {},
          configurable: true
        });
      } catch (e) { /* property may already be configured */ }
    }
    keepEnabled(prev);
    keepEnabled(next);
  }

  function init() {
    document.querySelectorAll('[data-vertical-thumbs]').forEach(initVerticalThumbs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
